import { styled } from "@mui/material/styles";
import { Box, Link, Paper, Typography } from "@mui/material";
import Posts from "../components/Posts";
// import SearchIcon from "@mui/icons-material/Search";
// import {
//   SearchIconWrapper,
//   SearchStyles,
//   StyledInputBase,
// } from "../mui-styles/SearchStyles";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: "black",
}));

// const Search = styled(Paper)(({ theme }) => ({
//   backgroundColor: "transparent",
//   ...theme.typography.body2,
//   color: "black",
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
// }));

export default function PostsPage() {
  return (
    <Box>
      <Typography sx={{ fontWeight: "bold", fontSize: 30 }}>
        📬 Latest Posts
      </Typography>
      {/* <Search>
        <Box sx={{ flexGrow: 1 }} />
        <SearchStyles>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ "aria-label": "search" }}
          />
        </SearchStyles>
      </Search> */}

      <Item elevation={0}>
        {" "}
        <Typography component="p" variant="body1">
          more articles{" "}
          <Link
            href="https://amirahnasihah.hashnode.dev/"
            target="_blank"
            sx={{ fontWeight: "bold", color: "#CFFAFE" }}
          >
            here
          </Link>{" "}
          👈
        </Typography>
      </Item>

      <Item>
        <Posts />
      </Item>
    </Box>
  );
}
